export const retrieveTicket = (dispatch, getState) => {

  const state = getState();

  if (state.features.tradeTicket) {

    dispatch({ type: "SET_TICKET_STATUS", status: "pending" });

    fetch(`${process.env.REACT_APP_API_URL}/portfolio/create_trade_ticket/?id=${state.analysis[0].id}&isoCode=${state.isoCode}`, {
      headers: {
        Authorization: state.token && `Token ${state.token}`
      }
    })
      .then(d => {
        if (d.status >= 400) {
          dispatch({ type: "SET_TICKET_STATUS", status: "unavailable" });
          return;
        } else {
          return d.blob().then(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.getElementById("ticket-url") || document.createElement("a");
            document.body.appendChild(a);
            a.setAttribute("id", "ticket-url");
            a.setAttribute("style", "display: none");
            if (window.navigator.msSaveOrOpenBlob) {
              a.addEventListener('click', () => window.navigator.msSaveOrOpenBlob(blob, "trade_ticket.xlsx"));
            } else {
              a.href = url;
              a.download = "trade_ticket.xlsx";
            }
            dispatch({ type: "SET_TICKET_STATUS", status: "export" });
          });
        }
      })
      .catch(error => {
        console.error(error);
        dispatch({ type: "SET_TICKET_STATUS", status: "unavailable" });
      });
  }
};

export const downloadTicket = (dispatch, getState) => {
  const state = getState();
  if (state.ticketStatus === "export") {
    const a = document.getElementById("ticket-url");
    a.click();
  }
};



// WEBPACK FOOTER //
// ./src/actions/get-trade-ticket.js